/* global axios */
import ApiClient from './ApiClient';

class ConversationApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  setNotificationMute(conversationID, muted) {
    return axios.post(`${this.url}/${conversationID}/notification_mute`, {
      muted,
    });
  }

  clear(conversationID) {
    return axios.post(`${this.url}/${conversationID}/clear`);
  }

  getLabels(conversationID) {
    return axios.get(`${this.url}/${conversationID}/labels`);
  }

  updateLabels(conversationID, labels) {
    return axios.post(`${this.url}/${conversationID}/labels`, { labels });
  }

  getUnreadCounts() {
    return axios.get(`${this.url}/unread_counts`);
  }

  getOpenCounts() {
    return axios.get(`${this.url}/open_counts`);
  }

  resolveAllOpen(params = {}) {
    return axios.post(`${this.url}/resolve_all`, params);
  }
}

export default new ConversationApi();
